import { axiosBaseQuery } from "app/auth/base";
import { createApi } from "@reduxjs/toolkit/query/react";

export const actionsApi = createApi({
  reducerPath: "configuracoesApp/configuracoes/actionsApi",
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    getOcorrenById: builder.query({
      query: (data) => ({
        url: "/ocorrencias",
        params: data,
      }),
      transformResponse: (response: any) => response.items ?? [],
    }),
    getVariavelById: builder.query({
      query: (data) => ({
        url: "/variaveis",
        params: data,
      }),
      transformResponse: (response: any) => response.items ?? [],
    }),
    getApelidoById: builder.query({
      query: (data) => ({
        url: "/transportadoraapelidos",
        params: data,
      }),
      transformResponse: (response: any) => response.items ?? [],
    }),
    getTransportadoraById: builder.query({
      query: (data) => ({
        url: "/transportadoras",
        params: data,
      }),
      transformResponse: (response: any) => response.items ?? [],
    }),
    getConfigAPIBarrarEntregaById: builder.query({
      query: (cnpjTransportadora) => ({
        url: `/barrar/entrega/${cnpjTransportadora}`,
      }),
      transformResponse: (response: any) => response.items ?? [],
    }),
  }),
});

export default actionsApi;
